import { GridDetailRowProps } from '@progress/kendo-react-grid';
import { GetString } from '../../StringResourceManager';

export const FirmwareDetail = (props: GridDetailRowProps) => {
  const dataItem = props.dataItem;
  const COLUMN_TITLE_FIRMWARE_CHECKSUM = GetString(
    'COLUMN_TITLE_FIRMWARE_CHECKSUM'
  );
  const COLUMN_TITLE_FIRMWARE_FILEPATH = GetString(
    'COLUMN_TITLE_FIRMWARE_FILEPATH'
  );
  return (
    <div>
      <section style={{ width: '900px', float: 'left' }}>
        <p>
          <strong>{COLUMN_TITLE_FIRMWARE_CHECKSUM}:</strong>{' '}
          {dataItem.FileChecksum}
        </p>
        <p>
          <strong>{COLUMN_TITLE_FIRMWARE_FILEPATH}:</strong> {dataItem.FilePath}
        </p>
      </section>
    </div>
  );
};
